import { MenuFoldOutlined, MenuUnfoldOutlined } from "@ant-design/icons";
import { useCommonStore } from "../../store";
// import { FilterOutlined } from "@ant-design/icons";
import { Drawer } from "antd";
import { closeIcon } from "../../assets";
import logo from "../../assets/phototime-logo-main.png";

const FooterFilterMobile = ({
  children,
}: {
  children?: any;
  isFilter?: boolean;
}) => {
  const { isSidebarOpen, setIsSidebarOpen, isOpenSort, setOpenSort } =
    useCommonStore();

  return (
    <>
      {isOpenSort && (
        <div className="">
          <Drawer
            placement="bottom"
            closable={false}
            onClose={() => setOpenSort(false)}
            open={isOpenSort}
            height={40}
          >
            <div className="w-full h-[66%] bg-white fixed left-0 -bottom-2 flex flex-col rounded-tl-2xl -gap-1 rounded-tr-2xl">
              <div className="w-full h-[8vh] bg-blue_primary flex justify-between items-center rounded-tl-2xl rounded-tr-2xl px-[1rem]">
                <div className="flex items-center gap-2"></div>
                <img
                  onClick={() => setOpenSort(false)}
                  className="cursor-pointer max-sm:w-5 w-6"
                  src={closeIcon}
                  alt="close"
                ></img>
              </div>
              <div className="px-6">{children}</div>
            </div>
          </Drawer>
        </div>
      )}
      <div className="lg:hidden bg-gray-200 w-screen min-h-[9vh] fixed top-0 left-0 sm:p-6 max-sm:p-3 flex justify-between items-center">
        {isSidebarOpen ? (
          <MenuUnfoldOutlined
            className="text-white text-xl sm:text-2xl max-sm:pr-[14px] pr-[18px]"
            onClick={() => setIsSidebarOpen(false)}
          />
        ) : (
          <div className="p-[10px] w-[100%] rounded-full flex justify-start gap-4 items-center">
            <div className="w-[30%] flex justify-start items-center">
              <MenuFoldOutlined
                className="text-gray-600 text-xl sm:text-2xl"
                onClick={() => setIsSidebarOpen(true)}
              />
            </div>
            <div className="w-[60%]">
              <img className="w-[50%]" src={logo}></img>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default FooterFilterMobile;
